import React from 'react'
import _ from "lodash";
import {COLOR_LIST} from "../../../../common/constants/color.constant";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

const EditStrokeDetails = ({parentForm, handleStrokeDetailsChanges}) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    return (
        <>

            <div className="ml-2 field-label">
                Stroke Color & Width
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="strokeColorKey"
                            name="strokeColorKey"
                            value={parentForm?.strokeColorKey}
                            onChange={(event) => {
                                handleStrokeDetailsChanges(event, parentForm);
                            }}>
                            {/*<option value="">Choose Stroke Color</option>*/}
                            <option value="">Choose Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="strokeColorCodeKey"
                            name="strokeColorCodeKey"
                            value={parentForm?.strokeColorCodeKey}
                            onChange={(event) => {
                                handleStrokeDetailsChanges(event, parentForm);
                            }}>
                            {/*<option value="">Choose Shade</option>*/}
                            <option value="">Choose Shade</option>
                            {colorMap[parentForm?.strokeColorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field w-28"
                            id="strokeWidth"
                            name="strokeWidth"
                            value={parentForm?.strokeWidth}
                            onChange={(event) => {
                                handleStrokeDetailsChanges(event, parentForm);
                            }}>
                        </input>
                    </div>

                </div>
            </div>

            {/*<div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="strokeColorKey"
                            name="strokeColorKey"
                            value={parentForm?.strokeColorKey}
                            onChange={(event) => {
                                handleStrokeDetailsChanges(event, parentForm);
                            }}>
                            <option value="">Choose Stroke Color</option>
                            <option value="">Choose Color</option>
                            {COLOR_LIST?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="strokeColorCodeKey"
                            name="strokeColorCodeKey"
                            value={parentForm?.strokeColorCodeKey}
                            onChange={(event) => {
                                handleStrokeDetailsChanges(event, parentForm);
                            }}>
                            <option value="">Choose Shade</option>
                            <option value="">Choose Shade</option>
                            {colorMap[parentForm?.strokeColorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                </div>
            </div>*/}

        </>
    )
}

export default EditStrokeDetails
